import { User } from '@app/core/models/user/user.model';
import { APIInfo } from '@app/core/models/user/api-info.model';

export class Account {
  user: User;
  apiInfo: APIInfo;
  settings: string[];

  constructor() {
    this.user = new User();
    this.apiInfo = new APIInfo();
  }
}
